module.exports = __webpack_public_path__ + "img/beaker-green-dark.297b5b52.png";